import type { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { Component, Inject, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { TranslateModule } from '@ngx-translate/core';
import { AutoClosedButtonComponent } from '@shared/components/auto-closed-button/auto-closed-button.component';
import { TrackerService } from '@shared/services/tracker.service';
import { browserBroadcastToken } from 'src/conf/di/angularProviderMapper';

@Component({
  selector: 'app-connection-to-external-bank-ok',
  templateUrl: './connection-to-external-bank-ok.component.html',
  standalone: true,
  imports: [TranslateModule, AutoClosedButtonComponent],
})
export class ConnectionToExternalBankOkComponent implements OnInit {
  constructor(
    private tracker: TrackerService,
    @Inject(browserBroadcastToken) private broadcastService: BrowserBroadcast
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'CONNECTION_EXTERNAL_BANK_OK' });
  }

  closeTab = () => {
    this.tracker.trackClick({
      taggingPage: 'CONNECTION_EXTERNAL_BANK_OK',
      click: frenchi18n.close_tab,
    });

    this.broadcastService.publish({ label: 'CLOSE_WEBAUTH_POPUP', data: null });
    window.close();
  };
}
